import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight, faExclamation,
  faGears,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faPalette,
} from "@fortawesome/free-solid-svg-icons";
import classes from "./pdfToolbar.module.scss";
import {Button, InputNumber, Popover, Modal, notification} from "antd";
import CursorPosition from "../cursor-position";
import { useDispatch, useSelector } from "react-redux";
import {selectPage, selectUrl} from "../../../../reducers/pdf-viewer/selectors";
import CursorSelection from "../cursor-selection";
import {
  selectCurrentActiveRectangleData,
  selectCurrentDrawingRectangle,
  selectCurrentPointerMode,
} from "../../../../reducers/editor/selectors";
import { POINTER_MODES } from "../../../../constants/editor";
import { setCurrentPointerMode } from "../../../../reducers/editor/actions";
import ColorSettingPopover from "./color-setting-popover";
import classNames from "classnames";
import { togglePreviewFunc } from "../../../../reducers/project/actions";
import ManageDefaultObjectSize from "../../../../components/manage-default-object-size";

const PDFToolbar = ({
  acceptedModes,
  changePage,
  totalPages,
  resetPage,
  scale,
  setZoom,
  resetZoom,
  cursorTopPdf,
  cursorLeftPdf,
}) => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectPage);
  const currentPointerMode = useSelector(selectCurrentPointerMode);
  const currentDrawingRectangle = useSelector(selectCurrentDrawingRectangle);
  const currentSelectedRectangle = useSelector(
    selectCurrentActiveRectangleData
  );
  const urlFile = useSelector(selectUrl);

  const [modal, contextHolder] = Modal.useModal();

  const prevPage = () => {
    if (currentPage <= 1) return;
    setPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage + 1 > totalPages) return;
    setPage(currentPage + 1);
  };

  const setPage = (page) => {
    changePage(page);
  };

  const zoomOut = () => {
    if (scale <= 10) return;
    handleSetZoom(scale - 10);
  };

  const zoomIn = () => {
    handleSetZoom(scale + 10);
  };

  const handleSetZoom = (zoom) => {
    setZoom(zoom);
  };

  const onChangeMode = (data) => {
    dispatch(setCurrentPointerMode(data));
  };

  // running preview
  const onPreview = () => {
    if (true){ //(urlFile) {
      dispatch(togglePreviewFunc(true));
    }
    /* 
    else {      
      notification.warning({
        message: "Please add at least one text, image object or change a pdf field and try again",
      });
    }
    */
    
  };

  const selectionData = useMemo(() => {
    if (currentSelectedRectangle) return currentSelectedRectangle;
    return currentDrawingRectangle;
  }, [currentDrawingRectangle, currentSelectedRectangle]);

  return (
    <>
      {contextHolder}
      <div className={classes.ToolbarWrap}>

        <div className={classes.LeftWrap}>
          <div className={classes.ColorSetting}>
            <Popover
              placement="bottomLeft"
              content={ColorSettingPopover}
              trigger="click"
            >
              <FontAwesomeIcon
                className={classNames(classes.ColorSettingIcon, "text-primary")}
                icon={faPalette}
              />
            </Popover>
          </div>

          {acceptedModes.includes(POINTER_MODES.SELECTION) && (
            <CursorSelection
              isActive={currentPointerMode === POINTER_MODES.SELECTION}
              selectionData={selectionData}
              onChangeMode={onChangeMode}
            />
          )}

          {acceptedModes.includes(POINTER_MODES.POSITION) && (
            <CursorPosition
              isActive={currentPointerMode === POINTER_MODES.POSITION}
              cursorLeftPdf={cursorLeftPdf}
              cursorTopPdf={cursorTopPdf}
              onChangeMode={onChangeMode}
            />
          )}

          {/*<ManageDefaultObjectSize/>*/}

        </div>

       <div className={classes.CenterWrap}>
         <div className={classes.NavigateWrap}>
           <Button
             className={classNames(classes.NavigateBtn)}
             onClick={prevPage}
             icon={
               <FontAwesomeIcon
                 className={classNames("text-primary")}
                 icon={faArrowLeft}
               />
             }
           />
           <InputNumber
             className={classes.NavigateInput}
             min={0}
             value={currentPage}
             onChange={(value) => setPage(value)}
             onBlur={resetPage}
             controls={false}
             addonAfter={
               <div>
                 {" "}
                 / <span className={classes.TotalPages}> {totalPages}</span>
               </div>
             }
           />

           <Button
             className={classes.NavigateBtn}
             onClick={nextPage}
             icon={
               <FontAwesomeIcon
                 className={classNames("text-primary")}
                 icon={faArrowRight}
               />
             }
           />
         </div>
         <div className={classes.ZoomWrap}>
           <Button
             className={classes.ZoomBtn}
             onClick={zoomOut}
             icon={
               <FontAwesomeIcon
                 className={classNames("text-primary")}
                 icon={faMagnifyingGlassMinus}
               />
             }
           />
           <InputNumber
             min={0}
             className={classes.ZoomInput}
             value={scale}
             onChange={(value) => handleSetZoom(value)}
             onBlur={resetZoom}
             controls={false}
             addonAfter={<div>%</div>}
           />

           <Button
             className={classes.ZoomBtn}
             onClick={zoomIn}
             icon={
               <FontAwesomeIcon
                 className={classNames("text-primary")}
                 icon={faMagnifyingGlassPlus}
               />
             }
           />
         </div>
       </div>

        <div>
          <button
            className={classNames(classes.Button, "btn btn-lg btn-success")}
            onClick={onPreview}
          >
            <FontAwesomeIcon icon={faGears} />
            <span className={"ml-2"}><strong>Generate PDF and Preview</strong></span>
          </button>
        </div>

      </div>
      <div className={classes.PreviewWrap}>
        <div>
        </div>
        <div>

        </div>
      </div>
    </>
  );
};

export default PDFToolbar;
